/* eslint-disable */
import { reactive } from "vue";

export const storage = reactive({
    'ALIENS_OWNED': {},
    'UPGRADES_LVLS': {},
    'SHIP_OWNED': {
        'spacebar': 1
    },
    'CURRENT_SHIP': 'spacebar',
    'ACHIEVEMENTS': {},
    'GALAXY_IND': 0,
    'CLICKS_ALL': 0,
    'MAXED_SPEED': 0,
    'BOOST_ON': false,
    'BOOST_NUM': 2,
    'NEXT_BOOST_TIME': null,
    'COINS': 0n,
    'PINK_COINS': 0,
    'BLACK_COINS': 0,
    'LAST_AWARD_TIME': null,
    'AUDIO_ON': true,
    'MUSIC_ON': true,
    'VERSION': 3,
    'RESET': false,
    'MAX_CLICKS': 0,
    'CLICK_PER_MIN': 0,
    'CLICK_PER_SEC': 0,
    'GLOW_ON': false,
    'ADD_ON': false
})